import {findIndex} from 'lodash';
import * as parameterActionTypes from './parameterActionTypes';

const parameterInitialState = {
  parameterList: []
};

const parameterReducer = (state = parameterInitialState, action) => {
  switch (action.type) {
    case parameterActionTypes.SET_PARAMETER_LIST:
      return {
        ...state,
        parameterList: [
          ...state.parameterList,
          ...action.parameterList
        ]
      };

    case parameterActionTypes.ADD_PARAMETER:
      return {
        ...state,
        parameterList: [
          ...state.parameterList,
          ...[action.parameter]
        ]
      };

    case parameterActionTypes.UPDATE_PARAMETER:
      {
        const {parameter} = action;
        return {
          ...state,
          parameterList: state
            .parameterList
            .map((p) => {
              if (p.id === parameter.id) 
                return parameter;
              return p;
            })
        };
      }

    case parameterActionTypes.DELETE_PARAMETER:
      {
        const {parameterId} = action;
        const parameterIndex = findIndex(state.parameterList, (parameter) => parameter.id === parameterId);
        return {
          ...state,
          parameterList: [
            ...state
              .parameterList
              .slice(0, parameterIndex),
            ...state
              .parameterList
              .slice(parameterIndex + 1)
          ]
        };
      }

    default:
      return state;
  }
};

export default parameterReducer;



// WEBPACK FOOTER //
// ./src/parameter/parameterReducer.js